import createIcon from '../../createIcon';

/**
 * @component @name TableChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDEwLjAySDE0LjVWMjFIOS41VjEwLjAyWk0xNi41IDIxSDE5LjVDMjAuNiAyMSAyMS41IDIwLjEgMjEuNSAxOVYxMEgxNi41VjIxWk0xOS41IDNINC41QzMuNCAzIDIuNSAzLjkgMi41IDVWOEgyMS41VjVDMjEuNSAzLjkgMjAuNiAzIDE5LjUgM1pNMi41IDE5QzIuNSAyMC4xIDMuNCAyMSA0LjUgMjFINy41VjEwSDIuNVYxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TableChart = createIcon('TableChart', [
  [
    'path',
    {
      d: 'M9.5 10.02H14.5V21H9.5V10.02ZM16.5 21H19.5C20.6 21 21.5 20.1 21.5 19V10H16.5V21ZM19.5 3H4.5C3.4 3 2.5 3.9 2.5 5V8H21.5V5C21.5 3.9 20.6 3 19.5 3ZM2.5 19C2.5 20.1 3.4 21 4.5 21H7.5V10H2.5V19Z',
      key: '1fhik1',
    },
  ],
]);

export default TableChart;
